//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppSocialBar from '../components/social/AppSocialBar.vue'

export default {
  components: {
    AppSocialBar,
  },
  transition: 'smooth',
  data: () => ({
    author: {},
  }),

  async fetch() {
    this.author = await this.$axios.$get('author')
  },

  computed: {
    authorImage() {
      let authorImage
      if (this.author.image) {
        const { baseUrl } = this.$config
        const { small, medium } = this.author.image?.formats
        if (this.$device.isMobile) {
          authorImage = baseUrl + small.url
        }
        if (this.$device.isTablet) {
          authorImage = baseUrl + medium.url
        }
        authorImage = baseUrl + this.author.image.url
      }
      return authorImage
    },
  },
}
